// import local dependencies
import './layout/overlay-menu';
import './layout/custom-video';
import './layout/common';
import './layout/posts';
import './layout/search';
import './layout/header';
import './layout/header-panel';
import './layout/product';
import './layout/inspiration';
import './layout/decor/decor-highlights';
import './layout/decor/decor-highlights-flooring';
import './layout/decor/decor-helpers';
import './layout/decor/decor-single';
import './layout/decor/decor-grid';
import './layout/decor/decor-panel';
import './layout/animation';
import './layout/pre-footer';
import './layout/infinite-load';
import './layout/popup';
import './layout/page-required-form-submission';

import './layout/blocks/decors-list'
import './layout/blocks/sheet-list'
import './layout/blocks/timeline'
import './layout/blocks/person'
import './layout/blocks/gallery'
import './layout/blocks/animated-values'
import './layout/blocks/lottie-animation'
import './layout/blocks/accordion'
import './layout/focus'


// WEBPACK FOOTER //
// ./scripts/main.js